import React from 'react';
import { connect } from 'react-redux';
import { setDevice } from '~redux_related/ui/actionCreators';
import { isSafari } from '~utils/helpers';

function DeviceUpdater({ device, setDevice }) {
    React.useEffect(() => {
        const changeUIDevice = () => {
            const windowWidth = isSafari() ? document.documentElement.clientWidth : window.innerWidth;
            if (windowWidth < 1160 && device !== 'mobile') {
                setDevice('mobile');
            }
            if (windowWidth > 1159 && device !== 'desktop') {
                setDevice('desktop');
            }
        };
        changeUIDevice();
        window.addEventListener('resize', changeUIDevice);
        return () => window.removeEventListener('resize', changeUIDevice, false);
    }, [ device, setDevice ]);
    return null;
}

const mapStateToProps = (state) => ({
    device: state.ui.device,
});

const mapDispatchToProps = (dispatch) => ({
    setDevice: (version) => dispatch(setDevice(version)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceUpdater);



// WEBPACK FOOTER //
// ./src/deviceUpdater.js